import { z } from 'zod';

export const limitTypeSchema = z.enum(['rolling', 'calendar', 'lifetime']);

export const calculationTypeSchema = z.enum(['gross', 'net']);

const limitObject = z.object({
    windowLengthInDays: z.number(),
    pendingLimitValue: z.number(),
    limitValueMax: z.number().nullable(),
    triggersWarningEmail: z.boolean(),
    hardLimit: z.boolean(),
    limitType: limitTypeSchema,
    calculationType: calculationTypeSchema,
});

export type LimitObjectType = z.infer<typeof limitObject>;

export const InputSchema = z.object({
    accountId: z.number(),
    payload: z.object({
        source: z.literal('backoffice'),
        list: z.array(limitObject),
    }),
});

export type InputType = z.infer<typeof InputSchema>;

const SuccessResponseSchema = z.object({});

export type SuccessResponseType = z.infer<typeof SuccessResponseSchema>;

export const ErrorResponseSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
    }),
});

export type ErrorResponseType = z.infer<typeof ErrorResponseSchema>;

export type ResponseType =
    | { responseStatus: 'success'; data: SuccessResponseType }
    | {
          responseStatus: 'error';
          data: ErrorResponseType;
      }
    | {
          responseStatus: 'apiError';
          status: number;
          data?: unknown;
      };
